import ProcessingSkeleton, { type MatterRecordSkeletonColumn } from '@/matter-asset-common/asset/MatterRecordProcessingSkeleton'

/**
 * Skeleton table shown while the first timeline build or events load is in flight. Thin wrapper
 * over the shared ProcessingSkeleton that supplies the timeline column set.
 */

// Mirrors the All Events columns of the timeline events table (rowNumber + Date/Description/Source),
// with their fixed widths, so columns don't shift when data lands.
const SKELETON_COLUMNS: MatterRecordSkeletonColumn[] = [
  { width: 35, label: '' },
  { width: 134, label: 'Date' },
  { width: 578, label: 'Description' },
  { width: 297, label: 'Source' },
]

export default function TimelineAssetProcessingSkeleton() {
  return <ProcessingSkeleton columns={SKELETON_COLUMNS} />
}
